export default "__VITE_ASSET__Dv8683uQ__"